import { createRef } from 'react'

export const searchBoxRef: React.RefObject<HTMLInputElement> = createRef()
